import { FormikHelpers } from "formik";
import PendingStatusForm from "./PendingStatusForm";
import { useGetPendingStatus } from "./api/getPendingStatus";
import { useEditPendingStatus } from "./api/editPendingStatus";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";


const EditPendingStatus = ({handleCloseModal, pendingStatusId}: EditPendingStatusProps)  => {
  const getPendingStatusQuery = useGetPendingStatus({pendingStatusId: pendingStatusId})
  const editPendingStatusMutation = useEditPendingStatus({data: {}, pendingStatusId});

  const handleSubmit = async (values: IPostEditPendingStatus, { setSubmitting }: FormikHelpers<IPostEditPendingStatus>): Promise<void> => {
    try {
      await editPendingStatusMutation.mutateAsync({
        data: values,
        pendingStatusId: pendingStatusId
      });
      handleCloseModal();
    }catch(error){
      console.log("values",values)
    } finally {
	    setSubmitting(false);
    }
  }

  if (getPendingStatusQuery.isLoading) {
    return (
      <div className="p-5">
        <LoadingSpinner />
      </div>
    )
  }

  if (getPendingStatusQuery.error) {
    return (
      <div>Υπήρξε κάποιο πρόβλημα στην ανάκτηση της Κατηγορίας Εκκρεμότητας.</div>
    )
  }

  return (
    <>
      {!getPendingStatusQuery.isLoading && getPendingStatusQuery.data &&
        <PendingStatusForm initialValues={getPendingStatusQuery.data} type="edit" onSubmit={handleSubmit} />
      }
    </>
  )
}

interface EditPendingStatusProps {
  pendingStatusId: number;
  handleCloseModal: () => void;
}

export default EditPendingStatus;